// Copyright (c) 2016 Deere & Company

import './file-upload.scss';
import {
    FormattedMessage,
    injectIntl,
    intlShape
} from 'react-intl';
import React, {Component, PropTypes} from 'react';
import {
    createErrorObject,
    errorAlertBar
} from '../../services/alert-bar';
import Dropzone from 'dropzone';
import DropzoneComponent from 'react-dropzone-component';
import {getFileUploadErrorMessage} from '../../services/file-service';
import {getStore} from '../../../store-factory';
import {oktaToken} from '../../services/okta';

Dropzone.confirm = (question, accepted) => accepted();
let dropzoneComponent;

const init = dropzone => {

    dropzoneComponent = dropzone;

};

function handleFileUploadSuccess(file) {

    this.handleFileUploadSuccess(file, dropzoneComponent);

}

function handleFileUploadError(file, errorMessage) {

    errorAlertBar(createErrorObject(this.intl.formatMessage({
        id: getFileUploadErrorMessage(errorMessage)
    })));

}

class FileUpload extends Component {

    constructor(props) {

        super(props);
        this.state = {
            djsConfig: {
                accept: this::this.accept,
                addRemoveLinks: true,
                headers: {
                    Authorization: '',
                    sapEnvironment: ''
                },
                maxFilesize: 100,
                ...this.props.djsConfig
            }

        };

    }

    async componentDidMount() {

        await this.setUploadHeaders();

    }

    async setUploadHeaders() {

        const accessToken = await oktaToken('accessToken');

        const state = await getStore().getState();

        const selectedSapEnvironment = state.appConfig.sapEnvironments.length > 0 ?
            state.appConfig.sapEnvironments.find(environment => environment.defaultVal).name :
            '';

        const preferredLanguage = state.user.details.settings.language.primaryLanguage.key.length ?
            state.user.details.settings.language.primaryLanguage.key :
            'EN';

        await this.setState({
            djsConfig: {
                ...this.state.djsConfig,
                headers: {
                    'Accept-Language': preferredLanguage,
                    Authorization: `Bearer ${accessToken.accessToken}`,
                    sapEnvironment: selectedSapEnvironment
                }
            }
        });

    }

    async accept(file, done) {

        // do this twice to work around a bug in the component, otherwise it will not get the new headers before the request is sent!

        await this.setUploadHeaders();

        await this.setUploadHeaders();

        done();

    }

    render() {

        const componentConfig = {
            postUrl: `/api/files?className=${this.props.serviceConfig.className}&classType=${this.props.serviceConfig.classType}&objectKey=${this.props.serviceConfig.objectKey}`
        };

        const eventHandlers = {
            error: this.props::handleFileUploadError,
            init,
            removedfile: this.props.handleFileDelete,
            success: this.props::handleFileUploadSuccess
        };

        return (

            <div className='file-upload'>
                <DropzoneComponent
                    config={componentConfig}
                    djsConfig={this.state.djsConfig}
                    eventHandlers={eventHandlers}
                >
                    <span className='required-label'>
                        <div className='dz-message'>
                            {this.props.isRequired && <sup>{'*'}</sup>}
                            <FormattedMessage id={this.props.displayMessage || 'FILE_UPLOAD_MESSAGE'}/>
                        </div>
                    </span>
                </DropzoneComponent>
            </div>
        );

    }

}

FileUpload.displayName = 'FileUpload';
FileUpload.propTypes = {
    displayMessage: PropTypes.string,
    djsConfig: PropTypes.object,
    handleFileDelete: PropTypes.func.isRequired,
    handleFileUploadError: PropTypes.func,
    handleFileUploadSuccess: PropTypes.func.isRequired,
    intl: intlShape,
    isRequired: PropTypes.bool.isRequired,
    serviceConfig: PropTypes.shape({
        className: PropTypes.string.isRequired,
        classType: PropTypes.string.isRequired,
        objectKey: PropTypes.string.isRequired
    }).isRequired
};

export default injectIntl(FileUpload);



// WEBPACK FOOTER //
// ./src/shared/components/file-upload/file-upload.js